<template>
    <v-container class="plan" v-if="plan != undefined && plan != null">
        <img
            :src="plan.icon"
            style="width: 140px;"
        />
        <v-card-text class="pa-0 text-h3 mb-5">{{ plan.name }}</v-card-text>
        <div style="height: 50px;">
          <v-card-text class="text-h4 pa-0">{{ resolvePlanOriginPrice(plan) }}</v-card-text>
          <v-container v-if="plan.discounted != 0" class="pa-0 d-flex justify-center gap-2">
              <v-card-text
                  class="text-h5 pa-0"
                  style="color: red;width: auto;"
              >
                  {{ discountPercent }}
              </v-card-text>
              <v-card-text class="text-h5 pa-0" style="text-decoration: line-through;width: auto;">{{ resolvePriceBeforeDiscount(plan) }}</v-card-text>
          </v-container>
        </div>
        <v-card-text
            v-for="(option, index) in plan.options.slice(0, 3)"
            :key="index"
            class="pa-0 text-body-2 mt-2"
        >
            <span class="text-h4 mt-2 ml-1">{{ option.value }}</span>
            <span>{{ option.title }}</span>
        </v-card-text>
        <v-container class="pa-0 d-flex align-center flex-wrap gap-1 mt-9" style="height: 63px;">
            <v-card-text
                v-for="(option, index) in plan.options.slice(3).filter(o => o.value === 'active').slice(0, 5)"
                :key="index"
                class="pa-0 text-body-2"
                style=" flex: none;width: auto;"
            >
                <span>{{ option.title }} </span>
                <span v-if="index !== plan.options.slice(3).filter(o => o.value === 'active').slice(0, 5).length - 1">،</span>
            </v-card-text>
            <span>{{ $t('etc') }}</span>
        </v-container>
        <v-btn
          color="primary"
          class="mt-5 w-100"
          v-if="plan.total_price > 0"
          @click="$emit('visitCheckout', plan)"
        >
        {{
          userCurrentPlan && (userCurrentPlan.plan_id == plan.id && userCurrentPlan.plan_duration_id == plan.duration_id) ?
          $t("renew-subscription") :
          $t('buy-subscription')
        }}
        </v-btn>
        <v-btn
          v-else-if="plan.total_price < 0"
          color="primary"
          class="mt-5 w-100"
          @click="visitContactUs"
        >
        <span>
          {{
            userCurrentPlan && (userCurrentPlan.plan_id == plan.id && userCurrentPlan.plan_duration_id == plan.duration_id) ?
            $t("renew-subscription") :
            $t('contact-with-us')
          }}
        </span>
        <span>021-28423686</span>
        </v-btn>
        <v-btn
          v-else-if="plan.total_price == 0"
          color="primary"
          class="mt-5 w-100"
          disabled
        >
        <span>{{ $t('checkoutAddonFree') }}</span>
        </v-btn>
        <v-btn
            color="secondary"
            outlined
            class="mt-2 w-100"
            @click="$emit('openMoreInfo', plan.id)"
        >
        {{ $t('more-info-about-plan') }}
        </v-btn>
    </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    plan: Object
  },
  data () {
    return {
      discountPercent: null
    }
  },
  computed: {
    ...mapState(['userCurrentPlan'])
  },
  methods: {
    resolvePlanOriginPrice (plan) {
      if (plan.discounted == 0) {
        if (plan.origin_price > 0) {
          return this.$numberFormat(plan.origin_price) + ' ' + this.$t('rial')
        }
        if (plan.origin_price == 0) {
          return this.$t('checkoutAddonFree')
        }
        if (plan.origin_price < 0) {
          return this.$t('contactus')
        }
      } else {
        return this.$numberFormat(this.resolvePriceAfterDiscount()) + ' ' + this.$t('rial')
      }
    },
    resolvePriceBeforeDiscount (plan) {
      if (plan.discounted != 0) {
        this.discountPercent = plan.discounted + '%' + this.$t('discount')
        return this.$numberFormat(plan.origin_price) + ' ' + this.$t('rial')
      }
    },
    resolvePriceAfterDiscount () {
      return this.plan.origin_price - (this.plan.origin_price * this.plan.discounted / 100)
    },
    visitContactUs () {
      window.open('https://abriron.com/%d8%aa%d9%85%d8%a7%d8%b3-%d8%a8%d8%a7-%d9%85%d8%a7/', '_blank')
    }
  }
}
</script>

<style scoped>
.plan {
    border: 1px solid #c0c0c066;
    border-radius: 4px;
    background-color: #fff;
    text-align: center;
}
::v-deep .v-btn__content {
  gap: .5rem;
}
</style>
